module.exports = __webpack_public_path__ + "img/car.5452c67e.png";